/* ==========================================================================
   LEHA Premium Product section
   Paired with sections/leha-product-main.liquid and assets/leha-product.css
   Replaces the inline <script> that previously lived in the section, which
   had three problems this file fixes:
     1. It bound on DOMContentLoaded only, so the section was dead after any
        re-render in the theme editor.
     2. It used document.querySelector('.leha-product'), so a second instance
        on the page would silently steal the first one's behaviour.
     3. It had no variant picker at all, so multi-variant products could only
        ever be bought in their first available variant.

   Deliberately NOT reusing the theme's <variant-radios> / <quantity-input>
   custom elements. Both are hard-coupled to main-product's DOM and throw on
   anything else: VariantSelects.onVariantChange() (global.js:943) calls
   addtocart_btnUpdated() and 
   (), which dereference
   '.target-allproducts__main input.add-to-cart-btn.button' and
   '[regular-price-sale]' with no null guard, and QuantityInput
   (global.js:206) calls this.closest('.main__product_right') unguarded.

   Add-to-cart itself IS delegated to the theme's store.js. See the section
   template for the four-part contract that makes that safe.
   ========================================================================== */

(function () {
  'use strict';

  if (window.LehaProductLifecycle) return;
  var initialised = new WeakMap();

  /* ----------------------------------------------------------------------
     Gallery + thumbnails
     ---------------------------------------------------------------------- */

  function initGallery(root, signal) {
    var gallery = root.querySelector('[data-leha-gallery]');
    var slides = Array.from(root.querySelectorAll('[data-leha-slide]'));
    if (!gallery || !slides.length) return null;
    var thumbs = Array.from(root.querySelectorAll('[data-leha-thumb]'));
    var content = root.querySelector('[data-leha-gallery-content]');
    var slot = root.querySelector('[data-leha-gallery-slot]');
    var dialog = root.querySelector('[data-leha-gallery-dialog]');
    var expanded = root.querySelector('[data-leha-gallery-expanded]');
    var closeButton = root.querySelector('[data-leha-gallery-close]');
    var counter = root.querySelector('[data-leha-counter-current]');
    var previous = root.querySelector('[data-leha-gallery-prev]');
    var next = root.querySelector('[data-leha-gallery-next]');
    var status = root.querySelector('[data-leha-gallery-status]');
    var active = Math.max(0, slides.findIndex(function (slide) { return slide.hasAttribute('data-leha-active'); }));
    var opened = false, opener = null, frame = 0, resizeFrame = 0, lock = null;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    var width = 0, playAttempt = 0;
    var modelScript;

    function error() { slides[active].removeAttribute('data-leha-playing'); slides[active].setAttribute('data-leha-failed', ''); if (status) status.textContent = gallery.dataset.lehaPlayError || ''; }
    function pause(slide, release) {
      slide.querySelectorAll('video').forEach(function (video) { video.pause(); });
      var player = slide.querySelector('[data-leha-player]');
      if (player && (release || slide.dataset.lehaMediaType !== 'video')) {
        player.replaceChildren();
        slide.removeAttribute('data-leha-mounted');
      }
    }
    function markCurrent(index) {
      if (!slides[index]) return;
      var changed = active !== index;
      if (changed) playAttempt++;
      active = index;
      if (changed && status) status.textContent = (gallery.dataset.lehaPosition || '').replace('__INDEX__', String(index + 1));
      gallery.dataset.lehaActiveIndex = String(index);
      slides.forEach(function (slide, i) {
        var current = i === index;
        slide.toggleAttribute('data-leha-active', current);
        slide.setAttribute('aria-hidden', current ? 'false' : 'true');
        slide.toggleAttribute('inert', !current);
        if (!current) pause(slide, false);
      });
      thumbs.forEach(function (thumb) {
        thumb.disabled = false;
        thumb.setAttribute('aria-current', Number(thumb.dataset.lehaThumb) === index ? 'true' : 'false');
      });
      if (counter) counter.textContent = String(index + 1);
      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    }
    function align(index, smooth) {
      var rect = gallery.getBoundingClientRect();
      var delta = slides[index].getBoundingClientRect().left - rect.left;
      if (typeof gallery.scrollBy === 'function') gallery.scrollBy({left: delta, behavior: smooth && !(reduced && reduced.matches) ? 'smooth' : 'auto'});
    }
    function goTo(index, smooth) {
      index = Math.max(0, Math.min(slides.length - 1, Number(index)));
      if (!Number.isInteger(index)) return;
      if (status) status.textContent = '';
      markCurrent(index);
      align(index, smooth);
      var thumb = thumbs.find(function (button) { return Number(button.dataset.lehaThumb) === index; });
      if (thumb && thumb.parentElement.scrollBy) {
        var strip = thumb.parentElement.getBoundingClientRect(), box = thumb.getBoundingClientRect();
        var delta = box.left < strip.left ? box.left - strip.left : box.right > strip.right ? box.right - strip.right : 0;
        thumb.parentElement.scrollBy({left: delta, behavior: 'auto'});
      }
    }
    function mount(slide) {
      var player = slide.querySelector('[data-leha-player]');
      var template = slide.querySelector('[data-leha-player-template]');
      if (!player || !template) return null;
      if (!slide.hasAttribute('data-leha-mounted')) {
        player.appendChild(template.content.cloneNode(true));
        slide.setAttribute('data-leha-mounted', '');
      }
      return player;
    }
    function play(slide) {
      if (slides.indexOf(slide) !== active || signal.aborted) return;
      slides.forEach(function (other) { if (other !== slide) pause(other, false); });
      var attemptId = ++playAttempt;
      var player = mount(slide);
      if (!player) return;
      if (status) status.textContent = '';
      slide.removeAttribute('data-leha-failed');
      var video = player.querySelector('video');
      if (video) {
        var attempt;
        try { attempt = video.play(); } catch (e) { error(); return; }
        if (attempt && attempt.catch) attempt.catch(function () {
          if (signal.aborted || attemptId !== playAttempt || slides.indexOf(slide) !== active) return;
          slide.removeAttribute('data-leha-playing'); error();
        });
        return;
      }
      var model = player.querySelector('model-viewer');
      if (model && !window.customElements.get('model-viewer')) {
        modelScript = document.querySelector('script[data-leha-model-loader]');
        if (!modelScript) {
          modelScript = document.createElement('script'); modelScript.type = 'module';
          modelScript.src = gallery.dataset.lehaModelScript;
          modelScript.setAttribute('data-leha-model-loader', '');
          modelScript.addEventListener('error', function () {
            modelScript.remove(); if (!signal.aborted) error();
          }, {once: true});
          document.head.appendChild(modelScript);
        }
      }
      var interactive = player.querySelector('iframe, model-viewer');
      if (interactive) interactive.focus();
    }
    function focusables() {
      return Array.from(dialog.querySelectorAll('button, a[href], video, iframe, model-viewer, [tabindex="0"]')).filter(function (el) {
        return !el.disabled && !el.closest('[inert], [hidden], [aria-hidden="true"]') && el.getClientRects().length;
      });
    }
    function openGallery(button) {
      if (opened || !dialog || !content || !expanded || !slot) return;
      opener = button;
      slot.style.minHeight = slot.getBoundingClientRect().height + 'px';
      lock = {x: window.scrollX, y: window.scrollY, styles: {}};
      ['position', 'top', 'left', 'width', 'overflow', 'padding-right'].forEach(function (key) { lock.styles[key] = {value: document.body.style.getPropertyValue(key), priority: document.body.style.getPropertyPriority(key)}; });
      var scrollbar = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
      document.body.style.position = 'fixed'; document.body.style.top = -lock.y + 'px';
      document.body.style.left = -lock.x + 'px'; document.body.style.width = '100%'; document.body.style.overflow = 'hidden';
      if (scrollbar) document.body.style.paddingRight = scrollbar + 'px';
      expanded.appendChild(content);
      opened = true; dialog.setAttribute('aria-modal', 'true');
      try { if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', ''); }
      catch (e) { closeGallery(); return; }
      if (closeButton) closeButton.focus();
      align(active, false);
    }
    function closeGallery() {
      if (!opened) return;
      opened = false; playAttempt++;
      slides.forEach(function (slide) { pause(slide, false); });
      slot.insertBefore(content, dialog);
      if (dialog.open && dialog.close) dialog.close(); else dialog.removeAttribute('open');
      dialog.removeAttribute('aria-modal'); slot.style.removeProperty('min-height');
      if (lock) {
        Object.keys(lock.styles).forEach(function (key) { var style = lock.styles[key]; if (style.value) document.body.style.setProperty(key, style.value, style.priority); else document.body.style.removeProperty(key); });
        window.scrollTo(lock.x, lock.y); lock = null;
      }
      align(active, false);
      if (opener && opener.isConnected && !opener.closest('[inert]')) opener.focus({preventScroll: true});
      else gallery.focus({preventScroll: true});
    }
    gallery.addEventListener('scroll', function () {
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        var left = gallery.getBoundingClientRect().left;
        var closest = active, distance = Infinity;
        slides.forEach(function (slide, i) { var value = Math.abs(slide.getBoundingClientRect().left - left); if (value < distance) { distance = value; closest = i; } });
        if (closest !== active) markCurrent(closest);
      });
    }, {passive: true, signal: signal});
    root.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-leha-thumb]');
      if (thumb && root.contains(thumb)) { goTo(Number(thumb.dataset.lehaThumb), true); return; }
      var button = event.target.closest('[data-leha-expand], [data-leha-play], [data-leha-gallery-prev], [data-leha-gallery-next], [data-leha-gallery-close]');
      if (!button || !root.contains(button)) return;
      if (button.hasAttribute('data-leha-gallery-prev')) goTo(active - 1, true);
      else if (button.hasAttribute('data-leha-gallery-next')) goTo(active + 1, true);
      else if (button.hasAttribute('data-leha-play')) play(button.closest('[data-leha-slide]'));
      else if (button.hasAttribute('data-leha-gallery-close')) closeGallery();
      else openGallery(button);
    }, {signal: signal});
    root.addEventListener('play', function (event) {
      if (event.target.tagName !== 'VIDEO') return;
      var slide = event.target.closest('[data-leha-slide]');
      if (!slide) return;
      if (slides.indexOf(slide) !== active) { event.target.pause(); return; }
      slide.setAttribute('data-leha-playing', '');
      slides.forEach(function (other) { if (other !== slide) pause(other, false); });
    }, {capture: true, signal: signal});
    root.addEventListener('pause', function (event) { if (event.target.tagName === 'VIDEO' && event.target.closest('[data-leha-slide]')) event.target.closest('[data-leha-slide]').removeAttribute('data-leha-playing'); }, {capture: true, signal: signal});
    root.addEventListener('ended', function (event) { if (event.target.tagName === 'VIDEO' && event.target.closest('[data-leha-slide]')) event.target.closest('[data-leha-slide]').removeAttribute('data-leha-playing'); }, {capture: true, signal: signal});
    root.addEventListener('error', function (event) { if (event.target.tagName === 'VIDEO' && slides.indexOf(event.target.closest('[data-leha-slide]')) === active) error(); }, {capture: true, signal: signal});
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && opened) { event.preventDefault(); closeGallery(); return; }
      if (event.key === 'Tab' && opened) {
        var controls = focusables(); var first = controls[0], last = controls[controls.length - 1];
        if (!first) { event.preventDefault(); closeButton.focus(); }
        else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        return;
      }
      if (event.target.closest('video, iframe, model-viewer, input, textarea, select')) return;
      if (!gallery.contains(event.target) && !(dialog && dialog.contains(event.target)) && !event.target.closest('[data-leha-thumb]')) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); var rtl = root.dir === 'rtl';
        goTo(active + ((event.key === 'ArrowLeft') === rtl ? 1 : -1), true);
      }
    }, {signal: signal});
    if (dialog) {
      dialog.addEventListener('cancel', function (event) { event.preventDefault(); closeGallery(); }, {signal: signal});
      dialog.addEventListener('close', closeGallery, {signal: signal});
    }
    document.addEventListener('focusin', function (event) { if (opened && !dialog.contains(event.target)) closeButton.focus(); }, {signal: signal});
    function resized() {
      var currentWidth = gallery.getBoundingClientRect().width;
      if (currentWidth === width) return;
      width = currentWidth;
      if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(function () { resizeFrame = 0; align(active, false); });
    }
    var observer = window.ResizeObserver ? new window.ResizeObserver(resized) : null;
    if (observer) observer.observe(gallery); else window.addEventListener('resize', resized, {signal: signal});
    gallery.setAttribute('data-leha-gallery-ready', '');
    goTo(active, false);
    return {goTo: goTo, dispose: function () {
      closeGallery(); slides.forEach(function (slide) { pause(slide, true); });
      if (observer) observer.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
      if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
      gallery.removeAttribute('data-leha-gallery-ready');
    }};
  }

  /* ----------------------------------------------------------------------
     Quantity
     ---------------------------------------------------------------------- */

  function initQuantity(root, signal) {
    var input = root.querySelector('[data-leha-qty-input]');
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-leha-qty]'));

    if (!input) return;

    function clamp(value) {
      var min = Number(input.min) || 1;
      var max = input.max ? Number(input.max) : Infinity;
      if (isNaN(value) || value < min) return min;
      if (value > max) value = max;
      var step = Number(input.step) || 1;
      return min + Math.floor((value - min) / step) * step;
    }

    function sync() {
      var value = clamp(Number(input.value));
      var min = Number(input.min) || 1;
      var max = input.max ? Number(input.max) : Infinity;
      var step = Number(input.step) || 1;

      input.value = value;

      buttons.forEach(function (button) {
        if (button.dataset.lehaQty === 'plus') button.disabled = value + step > max;
        if (button.dataset.lehaQty === 'minus') button.disabled = value - step < min;
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var step = (Number(input.step) || 1) * (this.dataset.lehaQty === 'plus' ? 1 : -1);
        input.value = clamp(Number(input.value) + step);
        sync();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }, {signal: signal});
    });

    input.addEventListener('change', sync, {signal: signal});
    input.addEventListener('blur', sync, {signal: signal});
    root.addEventListener('leha:pricing:updated', sync, {signal: signal});

    sync();
  }

  /* ----------------------------------------------------------------------
     Variants
     ---------------------------------------------------------------------- */

  function initVariants(root, gallery, signal) {
    var dataEl = root.querySelector('[data-leha-variants]');
    var picker = root.querySelector('[data-leha-options]');
    var idInput = root.querySelector('[data-leha-variant-id]');

    root.querySelectorAll('[data-leha-add], [data-leha-sticky-add]').forEach(function (button) { button.disabled = true; });
    if (!dataEl || !idInput) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      // Malformed JSON must not take the rest of the section down with it;
      // the form still works with whatever variant Liquid pre-selected.
      return;
    }
    if (!Array.isArray(variants) || !variants.length) return;

    var pageProductId = root.dataset.lehaProductId;
    var packages = Array.from(root.querySelectorAll('[data-leha-package-option]'));
    try {
      root.querySelectorAll('[data-leha-package-variant]').forEach(function (element) {
        var variant = JSON.parse(element.textContent);
        if (!variants.some(function (item) { return String(item.id) === String(variant.id); })) variants.push(variant);
      });
    } catch (error) { return; }

    var addButton = root.querySelector('[data-leha-add]');
    var pricing = window.LehaCommercialPricing && window.LehaCommercialPricing.create(root, variants);
    var returnInputs = new Map();
    var currentVariant = variants.find(function (variant) { return String(variant.id) === idInput.value; }) || null;
    packages.forEach(function (radio) { radio.checked = !!currentVariant && radio.value === String(currentVariant.id); });
    function localizationReturn() {
      if (!pricing || !currentVariant || document.querySelector('[data-leha-product]') !== root) return;
      var url = pricing.urlFor(currentVariant);
      url.searchParams.delete('country');
      url.searchParams.delete('currency');
      document.querySelectorAll('localization-form form').forEach(function (form) {
        var input = form.querySelector('[name="return_to"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden'; input.name = 'return_to';
          form.appendChild(input); returnInputs.set(input, null);
        } else if (!returnInputs.has(input)) returnInputs.set(input, input.value);
        input.value = url.pathname + url.search;
      });
    }
    signal.addEventListener('abort', function () {
      returnInputs.forEach(function (value, input) { if (value === null) input.remove(); else input.value = value; });
    }, {once: true});
    document.addEventListener('click', function (event) {
      if (event.target.closest('localization-form a[data-value]')) localizationReturn();
    }, {signal: signal, capture: true});

    function selected() {
      if (!picker) return [];
      return Array.prototype.slice
        .call(picker.querySelectorAll('[data-leha-option-value][aria-checked="true"]'))
        .sort(function (a, b) {
          return Number(a.dataset.lehaOptionPosition) - Number(b.dataset.lehaOptionPosition);
        })
        .map(function (el) {
          return el.dataset.lehaOptionValue;
        });
    }

    function match(options) {
      return variants.find(function (variant) {
        return (!variant.product_id || String(variant.product_id) === String(pageProductId)) && variant.options.every(function (value, index) {
          return options[index] === value;
        });
      });
    }

    // Grey out option values that cannot combine with the current selection.
    function markUnavailable(options) {
      if (!picker) return;
      Array.prototype.slice
        .call(picker.querySelectorAll('[data-leha-option-value]'))
        .forEach(function (el) {
          var probe = options.slice();
          probe[Number(el.dataset.lehaOptionPosition)] = el.dataset.lehaOptionValue;
          var candidate = match(probe);
          el.dataset.unavailable = candidate && candidate.available ? 'false' : 'true';
        });
    }

    function apply(variant) {
      currentVariant = variant;
      packages.forEach(function (radio) { radio.checked = !!variant && radio.value === String(variant.id); });
      if (picker && packages.length) picker.hidden = !!variant && String(variant.product_id) !== String(pageProductId);
      if (variant) {
        idInput.value = variant.id;
        if (addButton) addButton.setAttribute('product_id', variant.id);
      }

      if (pricing) pricing.select(variant);
      else root.querySelectorAll('[data-leha-add], [data-leha-sticky-add]').forEach(function (button) { button.disabled = true; });

      if (variant && gallery && (!variant.product_id || String(variant.product_id) === String(pageProductId)) && typeof variant.media_index === 'number' && variant.media_index >= 0) {
        gallery.goTo(variant.media_index, true);
      }

      if (variant && root.dataset.lehaUrl && window.history && window.history.replaceState) {
        var nextUrl = pricing && variant.product_url ? pricing.urlFor(variant) : new URL(window.location.href);
        nextUrl.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', nextUrl.href);
      }
      localizationReturn();

      // Let the currency converter app (and anything else) re-scan the
      // prices we just swapped in.
      root.dispatchEvent(
        new CustomEvent('leha:variant:change', {
          bubbles: true,
          detail: { variant: variant || null }
        })
      );
    }

    function choose(el) {
      var position = el.dataset.lehaOptionPosition;
      Array.prototype.slice
        .call(picker.querySelectorAll('[data-leha-option-position="' + position + '"]'))
        .forEach(function (sibling) {
          sibling.setAttribute('aria-checked', sibling === el ? 'true' : 'false');
          sibling.tabIndex = sibling === el ? 0 : -1;
        });

      var legend = picker.querySelector('[data-leha-option-current="' + position + '"]');
      if (legend) legend.textContent = el.dataset.lehaOptionValue;

      var options = selected();
      markUnavailable(options);
      apply(match(options));
    }

    packages.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) apply(variants.find(function (variant) { return String(variant.id) === radio.value; }) || null);
      }, {signal: signal});
    });
    root.addEventListener('leha:pricing:updated', function (event) {
      currentVariant = event.detail.variant;
      localizationReturn();
    }, {signal: signal});
    if (pricing) pricing.select(currentVariant);
    localizationReturn();

    if (picker) {
      var values = Array.prototype.slice.call(picker.querySelectorAll('[data-leha-option-value]'));

      values.forEach(function (el) {
        el.addEventListener('click', function () {
          choose(this);
        }, {signal: signal});

        // role="radio" carries a keyboard contract: arrows move and select.
        el.addEventListener('keydown', function (event) {
          var keys = ['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'];
          if (keys.indexOf(event.key) === -1) return;
          event.preventDefault();

          var group = Array.prototype.slice.call(
            picker.querySelectorAll(
              '[data-leha-option-position="' + this.dataset.lehaOptionPosition + '"]'
            )
          );
          var index = group.indexOf(this);
          var forward = event.key === 'ArrowRight' || event.key === 'ArrowDown';
          var next = group[(index + (forward ? 1 : -1) + group.length) % group.length];

          if (next) {
            choose(next);
            next.focus();
          }
        }, {signal: signal});
      });

      markUnavailable(selected());
    }
    return pricing;
  }

  /* ----------------------------------------------------------------------
     Sticky CTA
     ---------------------------------------------------------------------- */

  function initSticky(root, signal) {
    var stickyButton = root.querySelector('[data-leha-sticky-add]');
    var addButton = root.querySelector('[data-leha-add]');

    if (!stickyButton || !addButton) return;

    // The sticky button deliberately does NOT carry .product-form__submit.
    // store.js delegates on document click, so two matching buttons would
    // add the product twice. It forwards to the real submit instead.
    stickyButton.addEventListener('click', function () {
      if (addButton.disabled) return;
      addButton.click();
    }, {signal: signal});
  }

  /* ----------------------------------------------------------------------
     Boot
     ---------------------------------------------------------------------- */

  function dispose(root) {
    var owner = initialised.get(root);
    if (!owner) return;
    initialised.delete(root);
    owner.events.abort();
    if (owner.pricing) owner.pricing.dispose();
    if (owner.gallery) owner.gallery.dispose();
    owner.observer.disconnect();
  }

  function init(root) {
    if (!root || !root.isConnected || initialised.has(root)) return;
    var events = new AbortController();
    var gallery = initGallery(root, events.signal);
    initQuantity(root, events.signal);
    var pricing = initVariants(root, gallery, events.signal);
    initSticky(root, events.signal);
    var observer = new MutationObserver(function () { if (!root.isConnected) dispose(root); });
    initialised.set(root, {events: events, gallery: gallery, pricing: pricing, observer: observer});
    observer.observe(document.documentElement, {childList: true, subtree: true});
  }

  function initAll(scope) {
    var container = scope || document;
    if (container.matches && container.matches('[data-leha-product]')) init(container);
    Array.prototype.slice
      .call(container.querySelectorAll('[data-leha-product]'))
      .forEach(init);
  }

  window.LehaProductLifecycle = {init: initAll, dispose: dispose};

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    }, {once: true});
  } else {
    initAll();
  }

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target.matches && event.target.matches('[data-leha-product]')) dispose(event.target);
    event.target.querySelectorAll('[data-leha-product]').forEach(dispose);
  });
})();
